module.exports = __webpack_public_path__ + "img/booth-wind.ce551509.jpg";